
export const getLifecycle = <T extends string, K extends string>(storeName: T, actionName: K) => ({
    LOADING: `${storeName}__${actionName}/loading`,
    ERROR: `${storeName}__${actionName}/error`,
    SUCCESS: `${storeName}__${actionName}/success`,
    DROP_DATA: `${storeName}__${actionName}/drop_data`
});
